import { asWidgetProps } from 'Src/types/widget-helpers';
import React, { ComponentProps } from 'react';
import { isEmpty } from 'lodash';
import { ICONS } from 'Components/utils/icon/icons';
import { Icon } from 'Components/frameworks/icon/Icon';
type Props = {
  icon:
    | typeof ICONS.DATE
    | typeof ICONS.PEOPLE_DOUBLE
    | typeof ICONS.TRANSPORT
    | typeof ICONS.NO_TRANSPORT
    | typeof ICONS.BOAT
    | typeof ICONS.TRAIN;
  infos?: {
    text1: string;
    highlightText1?: string;
    text2?: string;
    highlightText2?: string;
  };
};

const Detail = ({ highlightText, text }) => {
  if (!text && !highlightText) {
    return null;
  }

  return (
    <p>
      {text}
      &nbsp;
      <strong className="text-sienna">{highlightText}</strong>
    </p>
  );
};

export const TravelDetail = ({ icon, infos }: Props) => (
  <div className="flex items-center gap-20 text-14">
    <Icon
      {...asWidgetProps<ComponentProps<typeof Icon>>({
        className: 'shrink-0 text-sienna',
        name: icon,
        width: '1.75rem',
      })}
    />
    {!isEmpty(infos ?? {}) && (
      <div className="flex-1">
        <Detail
          {...asWidgetProps<ComponentProps<typeof Detail>>({
            text: infos.text1,
            highlightText: infos.highlightText1,
          })}
        />
        <Detail
          {...asWidgetProps<ComponentProps<typeof Detail>>({
            text: infos.text2,
            highlightText: infos.highlightText2,
          })}
        />
      </div>
    )}
  </div>
);
